// Copyright 2026 L3montree GmbH and the DevGuard Contributors.
// SPDX-License-Identifier: 	AGPL-3.0-or-later

import type { Surface } from "@/lib/surface";
import { cn } from "@/lib/utils";
import type { DropzoneState } from "react-dropzone";

interface Props {
  dropzone: DropzoneState;
  files: string[];
  id?: string;
  // the surface the dropzone is rendered on
  variant?: Surface;
}
export default function FileUpload({ dropzone, files, id, variant }: Props) {
  return (
    <div
      id={id}
      className="border-muted-foreground border-2 border-dashed group p-1 rounded"
    >
      <div
        {...dropzone.getRootProps()}
        className={cn(
          "flex h-20 cursor-pointer items-center justify-center rounded dash-border",
          variant === "onCard" ? "bg-background" : "bg-card",
        )}
      >
        <input
          {...dropzone.getInputProps()}
          data-testid={id ? `file-upload-input-${id}` : "file-upload-input"}
        />
        {files.length > 0 ? (
          <div className="flex flex-col items-center">
            {files.map((file, index) => (
              <p key={index} className="text-muted-foreground">
                {file}
              </p>
            ))}
          </div>
        ) : (
          <p className="text-muted-foreground transition-all group-hover:text-primary">
            Drag and drop some file here, or click to select
          </p>
        )}
      </div>
    </div>
  );
}
